<template>
  <div class="flex flex-col container mx-auto my-10 sm:my-20 px-4">
    <h2 class="text-center">Projects</h2>
    <!-- school -->
    <div class="project-item flex">
      <div class="w-full sm:w-1/3 sm:px-8 project-item-text">
        <h3>Business Website</h3>
        <p>A dynamic and functional business website</p>
        <p>#Laravel #Vue #Tailwind</p>
        <a
          class="btn-visit"
          href="https://biz-school.bnextmedia.com.tw/"
          target="_blank"
          >Visit</a
        >
      </div>
      <div class="w-full sm:w-2/3">
        <img loading="lazy" src="https://i.imgur.com/6BYVUtz.gif" />
      </div>
    </div>
    <!-- top co. -->
    <div class="project-item flex">
      <div class="w-full sm:w-1/3 sm:px-8 project-item-text">
        <h3>Interactive Infographic Website</h3>
        <p>
          A one-page website visualizing data of the top 100 companies in Taiwan
        </p>
        <p>#Vue #Tailwind</p>
        <a
          class="btn-visit"
          href="https://edm.bnext.com.tw/taiwan-top-100-valuable-company-2021/"
          target="_blank"
          >Visit</a
        >
      </div>
      <div class="w-full sm:w-2/3">
        <img loading="lazy" src="https://i.imgur.com/aRDytO0.gif" />
      </div>
    </div>
    <!-- car -->
    <div class="project-item flex">
      <div class="w-full sm:w-1/3 sm:px-8 project-item-text">
        <h3>Interactive Storytelling Website</h3>
        <p>
          A one-page website visualize data of the electronic car industry chain
          in Taiwan
        </p>
        <p>#Vue #Tailwind</p>
        <a
          class="btn-visit"
          href="https://edm.bnext.com.tw/2021-automotive-supply-chain/"
          target="_blank"
          >Visit</a
        >
      </div>
      <div class="w-full sm:w-2/3">
        <img loading="lazy" src="https://i.imgur.com/CE6mXpL.gif" />
      </div>
    </div>
    <!-- FC -->
    <div class="project-item flex">
      <div class="w-full sm:w-1/3 sm:px-8 project-item-text">
        <h3>News Website</h3>
        <p>A contentful website reporting technology news</p>
        <p>#Laravel #Vue #Tailwind</p>
        <a class="btn-visit" href="https://fc.bnext.com.tw/" target="_blank"
          >Visit</a
        >
      </div>
      <div class="w-full sm:w-2/3">
        <img loading="lazy" src="https://i.imgur.com/NjraYLC.gif" />
      </div>
    </div>
    <!-- I-LIFE -->
    <div class="project-item flex">
      <div class="w-full sm:w-1/3 sm:px-8 project-item-text">
        <h3>Professional Website</h3>
        <p>A re-design project for a nonprofit organization</p>
        <p>#WordPress</p>
      </div>
      <div class="w-full sm:w-2/3">
        <img loading="lazy" src="https://i.imgur.com/OJBHGFJ.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Projects",
};
</script>

<style scoped>
.project-item {
  /* padding: 20px; */
  margin: 30px 0;
}

.project-item-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}

@media (max-width: 640px) {
  .project-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
}

.btn-visit {
  background: #FF5733;
  color: white;
  padding: 4px 16px;
  border-radius: 4px;
  margin: 8px 0;
  /* align-self: start; */
}
</style>